import Action from '../Action';

const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case Action.POST_VEHICLE_ENGINE_TYPE:
			return { ...state };
		case Action.UPDATE_VEHICLE_ENGINE_TYPE:
			return { ...state };
		case Action.DELETE_VEHICLE_ENGINE_TYPE:
			return { ...state };
		default:
			return state;
	}
};
